import { Builder } from '@builder.io/sdk';
import { RelatedHubs } from './RelatedHubs';

const RelatedHubsConfig = {
  name: 'RelatedHubs',
  friendlyName: 'Related Hubs',
  description: 'A list of links to related content hubs. Shows a heading with clickable pill-style buttons.',
  inputs: [
    {
      name: 'title',
      type: 'string',
      friendlyName: 'Heading',
      defaultValue: 'Related hubs',
      helperText: 'Title displayed above the hub links.',
    },
    {
      name: 'hubs',
      type: 'list',
      friendlyName: 'Hub Links',
      helperText: 'Add the hubs you want to link to. Each needs a label and a URL.',
      subFields: [
        {
          name: 'label',
          type: 'string',
          required: true,
          friendlyName: 'Hub Name',
          helperText: 'Text shown on the button (e.g. "Learner Drivers").',
        },
        {
          name: 'url',
          type: 'url',
          required: true,
          friendlyName: 'Link',
          helperText: 'URL this hub button links to.',
        },
      ],
    },
  ],
};

Builder.registerComponent(RelatedHubs, RelatedHubsConfig);
